<h2 mat-dialog-title>Test {{ data?.id ? "bearbeiten" : "anlegen" }}</h2>
<div class="pixl-form">
    <mat-divider></mat-divider>

    <mat-dialog-content [formGroup]="form" class="grid">
        <mat-form-field class="full-width">
            <mat-label>Name</mat-label>
            <input matInput formControlName="name" />
        </mat-form-field>

        <mat-form-field>
            <mat-label>Anwendung</mat-label>
            <mat-select formControlName="consumers">
                @for (consumer of consumers$ | async; track consumer) {
                    <mat-option [value]="consumer.id">{{ consumer.name }}</mat-option>
                }
            </mat-select>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Fach</mat-label>
            <mat-select formControlName="subjects">
                @for (subject of subjects$ | async; track subject) {
                    <mat-option [value]="subject.id">{{ subject.name }}</mat-option>
                }
            </mat-select>
        </mat-form-field>

        <div class="border-area full-width">
            <div class="multi-select mt-2">
                <pixl-multi-combo-entity-search
                    [label]="'Sequenzen'"
                    [observable$]="sequences$"
                    [namingColumn]="'name'"
                    [externalSearch]="true"
                    (onStateChange)="receiveSequenceData($event)"
                    (onSearchChange)="receiveSequenceSearchQuery($event)"
                    (scrolledToEnd)="loadMoreSequences($event)"
                    [(selectedValues)]="selectedSequences"
                >
                </pixl-multi-combo-entity-search>
            </div>
            <div class="mb-1">Anordnen (Drag'n Drop)</div>
            <div cdkDropList class="order-list" (cdkDropListDropped)="reOrderSelectedSequences($event)">
                <!-- eslint-disable-next-line @angular-eslint/template/prefer-control-flow -->
                <div *ngFor="let sequence of selectedSequences; trackBy: trackById" class="order-box" cdkDrag>
                    {{ sequence.name }}
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <br />
    <mat-divider></mat-divider>
    <mat-dialog-actions align="end">
        <button mat-button (click)="cancel()">Abbrechen</button>
        <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid">Speichern</button>
    </mat-dialog-actions>
</div>
